export enum OfferImportStatusEnum {
  Ready = 1,
  InProgress,
  Done,
}
